import React from 'react';
import LegalPage from '../components/LegalPage';

const TermsAndConditions = () => {
  return (
    <LegalPage title="Terms and Conditions">
      <div className="col-lg-12 mx-auto">
        <h4 className="mt-4">1. Website Ownership</h4>
        <p>This website is owned and operated by Cyberidge Construction Pty Ltd ("the Company").</p>
        
        <h4 className="mt-4">2. Information Disclaimer</h4>
        <p>All information provided on this website is published in good faith and intended for general reference only. While the Company endeavours to maintain the accuracy and timeliness of the content, no representations or warranties (express or implied) are made regarding its completeness, accuracy, reliability, or suitability for any particular purpose.</p>
        <p>All images, plans, diagrams, and descriptions are for illustrative purposes only and may differ from the final product or service. Information may be changed or updated without notice.</p>
        
        <h4 className="mt-4">3. Limitation of Liability</h4>
        <p>To the maximum extent permitted by law, Cyberidge Construction Pty Ltd, its affiliates, employees, and agents shall not be liable for any direct or indirect loss, damage, or expense arising from your access to or use of, or reliance on, any information contained on this website.</p>
        
        <h4 className="mt-4">4. Intellectual Property</h4>
        <p>All content on this website—including but not limited to text, images, graphics, plans, designs, and multimedia materials—is the property of Cyberidge Construction Pty Ltd and is protected by copyright and intellectual property laws. No part of the website may be copied, reproduced, republished, distributed, or used for commercial purposes without the Company's prior written consent.</p>
        
        <h4 className="mt-4">5. Website Availability and User Responsibility</h4>
        <p>The Company does not guarantee that this website will always be available, uninterrupted, or error-free, nor that it will be free of viruses or other harmful components. Users are responsible for ensuring their own protection against potential threats or data loss when using this website.</p>
        
        <h4 className="mt-4">6. Third-Party References</h4>
        <p>Any mention of third-party trademarks, companies, or websites is provided for informational purposes only and does not constitute endorsement or recommendation by the Company. Users are advised to conduct their own due diligence before making business, financial, or personal decisions based on any third-party information.</p>
        
        <h4 className="mt-4">7. Amendments</h4>
        <p>The Company reserves the right to modify or update these terms and conditions at any time without prior notice. All changes take effect immediately upon posting on this website. Users are encouraged to review this page regularly to stay informed of any updates.</p>
        
        <h4 className="mt-4">8. Contact Us</h4>
        <p>
          If you have any questions or concerns about these terms and conditions, please contact us:<br />
          Cyberidge Construction Pty Ltd<br />
          Address: 3/22-28 Melbourne St, North Adelaide, SA 5006<br />
          Email: info@cyberidge.com.au<br />
          Phone: (08) 8257 9123
        </p>
        
        <p className="mt-5">By using this website, you acknowledge that you have read, understood, and agreed to be bound by these terms and conditions.</p>
      </div>
    </LegalPage>
  );
};

export default TermsAndConditions; 